var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msgCount == 0)?_c('div',{attrs:{"id":"msg-dependencies"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }